var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlecheGR(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FF0000;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,640.000000) scale(0.100000,-0.100000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M211.8,6348.8c9.7,9.7,11.4,25.8,3.9,37.2c-4.1,6.2-10.2,11-16.9,13c-4,1.1-11.5,1.4-15.8,0.4 c-2-0.4-5.1-1.5-6.9-2.5c-1.8-0.9-19.5-13.2-39.3-27.3c-19.8-14.1-55.9-39.8-80.2-57.1c-29.7-21.1-45.5-32.7-47.9-35.1 c-10.7-10.6-11.6-27.3-2.2-39.7c2.7-3.6,159.6-130.9,164.8-133.7c12-6.5,26.6-4.5,36.2,5.1c6.1,6.1,9.1,13.1,9,21.6 c-0.1,7.3-1.9,12.9-6.3,18.5c-1.2,1.6-18.3,15.8-45,37.6l-43.1,34.9l-38.3,34.6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlecheGR);
export default __webpack_public_path__ + "static/media/fleche_g_r.a09fede3e6cdc4b31b0650257a3f9c5f.svg";
export { ForwardRef as ReactComponent };